<template>
    <div>
        <div class="msg" :class="{ expanded: expand }">
            <v-select v-model="entity_type" :items="getEntitiesType" :label="getI18n('contact_relationship.new.type')"></v-select>
            <v-select  v-show="entity_type && entity_type != 1" v-model="event_id" :items="getEvents" :label="getI18n('event')"></v-select>
            <v-autocomplete
            v-model="entity_id"
            :items="getResults"
            :search-input.sync="search"
            :label="getI18n( getEntityName )"
            v-show="entity_type"
        ></v-autocomplete>
            <v-select v-show="entity_type" v-model="contact_type" :items="getContactsType" :label="getI18n('role')"></v-select>
        </div>
        <!-- Staff Params -->
        <div v-if="entity_type == 2 && ( contact_type == 1 || contact_type == 2 )" class="msg expanded" v-show="expand">
            <v-select v-model="level" :items="getStaffLevels" :label="getI18n('staff.level')"></v-select>
        </div>
        <!-- Player Params -->
        <div v-if="entity_type == 2 && contact_type == 107" class="msg expanded" v-show="expand">
            <v-text-field :label="getI18n('tall')" v-model="tall" outline></v-text-field>
            <v-text-field :label="getI18n('params.number')" v-model="number" outline></v-text-field>
            <v-select v-model="position" :items="getPlayerPositions" :label="getI18n('player.position')"></v-select>
            <v-switch v-model="b_medication" :label="getI18n('need_medication' )"></v-switch>
            <v-textarea outline v-model="medication" :label="getI18n( 'medication' )" v-if="b_medication" value=""></v-textarea>
            <v-switch v-model="swim" :label="getI18n('swim' )"></v-switch>
        </div>
    </div>
</template>

<script>

    import i18n from '@/i18n'
    import store from '@/store'

    export default {
        props: { params: Array, actions: Array },
        components: { },
        data() {
            return {
                entity_type: false,
                contact_type: false,
                entity_id: false,
                event_id: false,
                entities_loaded: [],
                entities: {},
                search: "",
                expand: false,
                level: false,
                tall: '',
                number: '',
                position: null,
                b_medication: false,
                medication: '',
                swim: false
            }
        },
        computed: {
            getEntitiesType() {
                return [
                    { text: i18n.t( 'club' ), value: 1 },
                    { text: i18n.t( 'team' ), value: 2 },
                    { text: i18n.t( 'company' ), value: 5 },
                    { text: i18n.t( 'hotel' ), value: 3 },
                    { text: i18n.t( 'facility' ), value: 4 },

                ];
            },

            getContactsType() {
                var aContactTypes = store.getters[ 'persons/getContactTypes' ]( this.entity_type );
                var aReturn = [];
                var self = this;
                aContactTypes.forEach( type => {
                    if( type.type == self.entity_type ){
                        aReturn.push( { text: type.name, value: type.id } );
                    }
                });

                return aReturn;
            },

            getResults: function(){
                if( this.entity_type ){
                    this.getEntity();

                    var aItems = store.getters[ this.getEntityName + "/getList" ]();
                    var aResult = [];
                    aItems.forEach( item => {
                        if( this.getEntityName != 'teams' ){
                            aResult.push( { text: item.name, value: item.id } );
                        }
                        else{
                            if( this.event_id == item.event.id ){
                                aResult.push( { text: ( ( item.name != null )? item.name : item.club.name ) + ' - ' + item.category.name, value: item.id } );
                            }
                        }
                    });
                    return aResult;
                }
            },

            getEvents() {
                var events = store.getters[ 'events/getActives' ]();
                var aEvents = [];
                var self = this;
                events.forEach( event => {
                    aEvents.push( { text: self.formatEventName( event.name, event.edition ), value: event.id } );
                })

                return aEvents;
            },

            getPlayerPositions(){
                var aPositions = ObjectToArray( store.getters[ 'persons/getPositions' ]() );
                var aReturn = []

                for( var k in aPositions ){
                    var position = aPositions[ k ]
                    aReturn.push( { text: this.getI18n(position.name), value: position.id } )
                }

                return aReturn

            },

            getEntityName( ){
                var entity = '';
                switch( this.entity_type ){
                    case 1: entity = 'clubs';
                            break;
                    case 2: entity = 'teams';
                            break;
                    case 3: entity = 'hotels';
                            break;
                    case 4: entity = 'facilitys';
                            break;
                    case 5: entity = 'companies';
                            break;
                }
                
                return entity;
            },

            getStaffLevels() {
                return [];
            }
        },
        methods: {
            getLabel() {
                return 'test';
            },

            getI18n( label ){
                return i18n.t( label );
            },

            getEntity( ){
                var entity = false;
                switch( this.entity_type ){
                    case 1: entity = 'clubs';
                            break;
                    case 2: entity = 'teams';
                            break;
                    case 3: entity = 'hotels';
                            break;
                    case 4: entity = 'facilitys';
                            break;
                    case 5: entity = 'companies';
                            break;
                }

                if( entity && typeof this.entities_loaded[ entity ] === 'undefined' ){
                    var self = this;
                    self.entities_loaded[ entity ] = 1;
                    store.dispatch( entity + '/loadList' ).then( function(){
                    });
                }
            },
            
            formatEventName( name, edition ){
                return name + "'" + edition.substring(2);
            },
            
            formatEventUrl( name, edition ){
                return '/event/' + ( name + edition.substring(2) ).toLowerCase();
            }
        },

        watch: {
            entity_type: function () {
                var expand = this.entity_type == 2 && this.contact_type;
                this.expand = expand;
                this.$emit( 'expand', expand );
            },

            contact_type: function () {
                var expand = this.entity_type == 2;
                this.expand = expand;
                this.$emit( 'expand', expand );
            }
        }
    }
</script>

<style lang="scss">
    .msg {
        width: 100%;
        float: left;
        padding: 30px 20px;
        overflow: hidden;

        &.expanded {
            width: 50%;
        }
    }

    .v-input:not( .v-input--radio-group ) .v-input__slot {
        border: none !important;
        border-bottom: 2px solid rgba(0,0,0,.14) !important;
        border-radius: 0 !important;
        padding-left: 0 !important;
    }

    .item {
        text-align: center;
        margin: 10px auto;
        width: fit-content;

        &.strong .value {
            font-weight: bold;
            font-size: 22px;
        }

        &.textarea {
            min-height: 200px;
            width: 100%;
            /* text-overflow: ellipsis; */
            word-wrap: break-word;

            &.disabled {
                border: 1px solid #ccc;
                padding: 10px 20px;
                border-radius: 10px;
            }

            .value {
                min-height: 200px;
                width: 100%;

                textarea {
                    width: 100% !important;
                    min-height: 200px;
                    padding: 15px !important;
                }
            }
        }
    }
</style>